import styled, { css } from "styled-components";
import { font } from "../../../atoms/typography";
import { color } from "../../../atoms/colors";

export const ContentWrap = styled.div`
  padding: 0 30px;
`

export const CardGrid = styled.div`
  max-width: 506px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 32px; 
  @media (min-width: 577px) {
    grid-row-gap: 56px;
    max-width: 770px;
  }
  @media (min-width: 993px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 56px;
    max-width: 1170px;
  }
`

export const CardWrap = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  width: 100%;
  height: 100%;
  z-index: 0;
  .background-image {
    position: absolute;
    height: 200%;
    bottom: 0;
    right: 0;
    width: 200%;
    border-radius: 6px;
  }
`

export const CtaCard = styled.div`
  ${({ number })=> number === `card-0` ? css`
    background: linear-gradient(135deg, rgba(37, 15, 79, 0.85) 0%, rgba(185, 76, 246, 0.50) 98.02%);
  ` : number === `card-1` && css`
    background: linear-gradient(180deg, #090069 0%, rgba(9, 0, 105, 0.20) 98.02%);
  `}
  width: 100%;
  height: 100%;
  color: ${color.common.white};
  padding: 40px;
  border-radius: 6px !important;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative; 
  z-index: 1;
`

export const TextContent = styled.div`
  display: grid;
  grid-row-gap: 24px;
`

export const Heading = styled.h3`
  ${font("display", "sm", "700")}
`

export const Subheading = styled.div`
  ${font("text", "lg", "400")}
  p {
    margin-bottom: 0!important;
  }
  a {
    color: ${color.common.white};
  }
`

export const CTAWrap = styled.div`
  margin-top: auto;
  button {
    width: 100%;
  }
  @media (min-width: 577px) {
    button {
      width: unset;
    }
  }
`

export const LogoWrap = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 50px);
  gap: 12px;
  @media (min-width: 577px) {
    grid-template-columns: repeat(3, 80px);
  }
`

export const LogoLink = styled.a`
  background-color: ${color.common.workgridBlue};
  border-radius: 6px;
  transition: background-color 150ms ease;
  padding: 10px;
  svg {
    width: 30px;
    height: 30px;
  }
  &:hover {
    background-color: ${color.common.hoverBlue};
  }
  @media (min-width: 577px) {
    padding: 20px;
    svg {
      width: 40px;
      height: 40px;
    }
  }
`